import React, { Component } from 'react';

import css from './style.css';
import _ from 'lodash/string';
import isNil from 'lodash/isNil';
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import cs from "classnames";
import format from 'date-fns/format';
import mapDispatch from "~/misc/mapDispatch";
import { getUrlQeury } from "~/misc/formatUrlquery";
import { track } from "~/misc/metrics";
import PaymentOptions from "~/pages/Payment/components/PaymentOptions";
import Spinner from "~/components/common/Spinner";
import { getPaymentInfosAction } from "~/modules/hp/actions";
import { saveOrderInfoAction,savePayInfoAction,saveOrderStatusAction,setOrderLoadingStatusAction} from "~/modules/payment/actions";
import {modalClose} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import vipShownameTransfer from "~/components/pages/vipShownameTransfer.js";
import { regEmail, regPhone, regPassWord, regDot, regMc } from "~/misc/reg";
import Stripe from "~/components/pages/Stripe";
import LoadingSpiner from "~/components/pages/MyAccount/share/LoadingSpiner";
import EndingPage from "~/components/pages/EndingPage";
import Button from "~/components/common/Button";
import {
  saveAccountAction,
  billInfoAction,
  getPaymentInfoAction,
  payOrderAction,
} from "../../apis/payment";


import Input from "~/components/pages/MyAccount/share/Input";
import Content from '../../../../components/Modal/Content';


const text = {
  empty: "This field is required!",
  dot: {
    wrong: "Not a valid DOT!",
    invaild: "Not a valid DOT!",
  },
  termOfService: {
    empty: "Please read and accept our terms.",
  },
  stripeTerm: {
    empty: "Please read and accept our terms.",
  },
  email: {
    wrong: "Enter a valid email!",
  },
  phone: {
    wrong: "Enter a valid phone number!",
  },
  firstName: {
    wrong: "20 char limit",
  },
  lastName: {
    wrong: "20 char limit",
  },
};

const CheckBox = ({ checked, onClick, children, error }) => {
  return (
    <div>
      <div onClick={onClick} className={css.checkBoxWarp}>
        <div
          className={cs(css.cleckBoxBox, {
            [css.cleckBoxActive]: checked,
          })}
        ></div>
        <div className={css.cleckBoxContent}>{children}</div>
      </div>
      {error && <div className={css.error}>{error}</div>}
    </div>
  );
};

const OrderForm = ({ handleChange, handleBlur, form, error }) => {
  return (
    <form className={css.orderForm}>
      <Input
        label={"firstName"}
        type="text"
        title={"First Name"}
        defaultValue={form.firstName}
        fnChange={(e) => handleChange("firstName", e.target.value)}
        fnBlur={(e) => handleBlur("firstName", e.target.value)}
        error={error.firstName ? error.firstName : ""}
      />
      <Input
        label={"lastName"}
        type="text"
        title={"Last Name"}
        defaultValue={form.lastName}
        fnChange={(e) => handleChange("lastName", e.target.value)}
        fnBlur={(e) => handleBlur("lastName", e.target.value)}
        error={error.lastName ? error.lastName : ""}
      />
      <Input
        label={"email"}
        type="text"
        title={"Email"}
        defaultValue={form.email}
        fnChange={(e) => handleChange("email", e.target.value)}
        fnBlur={(e) => handleBlur("email", e.target.value)}
        error={error.email ? error.email : ""}
      />
      <Input
        label={"address"}
        type="text"
        title={"Billing Address"}
        defaultValue={form.address}
        fnChange={(e) => handleChange("address", e.target.value)}
        fnBlur={(e) => handleBlur("address", e.target.value)}
        error={error.address ? error.address : ""}
      />
    </form>
  );
};

const membershipLevel = {
  essential: 2,
  preferred: 3,
  ultimate: 4,
};


class MembershipPlansModal extends Component {
  constructor(props) {
    super(props);
    const { user,context,account,payment } = props;
    const {accountLastBillingInfo} = context

    const hasBillInfo = !isNil(accountLastBillingInfo);
    
    this.state = {
      stage: 1,
      stageText: ['Activate Membership', 'Done!'],
      selectedBill: {},
      bills: [],
      loading: false,
      form: {
        firstName: hasBillInfo
          ? accountLastBillingInfo.first_name || user.firstName
          : user.firstName || '',
        lastName: hasBillInfo
          ? accountLastBillingInfo.last_name || user.lastName
          : user.lastName || '',
        email: hasBillInfo ? accountLastBillingInfo.email || user.email : user.email || '',
        address: hasBillInfo
          ? accountLastBillingInfo.street_address || user.streetAddress
          : user.streetAddress || '',
        trems: false,
      },
      error: {
        firstName: '',
        lastName: '',
        email: '',
        address: '',
        trems: '',
      },
      paymentCodes: false,
      submitLoading: false,
      orderStatus: '',
      paymentType: '',
    };
  }
  componentDidMount(){
    // get user billing info
  }
  checkField = (key) => {
    const { form } = this.state;
    const value = form[key];
    switch (key) {
      case "email": {
        if (!regEmail.test(value)) {
          return text.email.wrong;
        }
        break;
      }
      case "firstName":{
        if (value.length > 20) {
          return text.firstName.wrong;
        }
        break;
      }
      case "lastName": {
        if (value.length > 20) {
          return text.firstName.wrong;
        }
        break;
      }
      case "address":{
        if (!value.length) {
          return text.empty
        }
        break;
      }
    }
  };
  checkFieldEmpty = (key) => {
    if(key == 'trems')return;
    const { form } = this.state;
    if (form[key] == false) {
      return (text[key] && text[key].empty) || text.empty;
    }
  };
  checkSingleField = (key) => {
    let error = {
      ...this.state.error,
    };
    error[key] = this.checkFieldEmpty(key) || this.checkField(key);
    this.setState({
      error,
    });
  };
  checkAllField = () => {
    const { form } = this.state;
    let error = {};
    //special check
    Object.keys(form).map((key) => {
      error[key] = this.checkField(key);
    });
    // empty value check
    Object.keys(form).map((key) => {
      if (form[key] == false) {
        error[key] = this.checkFieldEmpty(key);
      }
    });
    this.setState({
      error,
    });
    return Object.values(error).some((e) => e);
  };
  handleSubmit = () => { 
    if (this.state.submitLoading) return;
    const query = getUrlQeury();
    if (!isEmpty(query) && query.from) {
      track("pruchase_submit", { source: query.from });
    }
    // const error = this.checkAllField();
    // if (error) return;
    const { user, saveAccount, billInfo, getPaymentInfo,payment,setOrderLoadingStatus,context } = this.props;
    const {seat_num} = context
    const { selectedBill,form } = this.state;

    this.setState({
      paymentError: "",
      submitLoading: true,
    });
    // To build order
    saveAccount({
      promotionCode: "vip",
      billCycle: selectedBill.bill_cycle,
      unitPrice: selectedBill.discount_price,
      currentCost: selectedBill.discount_price,
      billFirstname: form.firstName,
      billLastname: form.lastName,
      billEmail: form.email,
    }).then((res) => {
      if (!res) return;
      // To set order info
      billInfo({
        plan: 0,
        product: {
          seat_num: seat_num || 1,
          origin_price: selectedBill.origin_price,
          show_name: selectedBill.show_name,
          discount_price: selectedBill.discount_price,
          pay_option: {
            key: selectedBill.key,
          },
          show_description: selectedBill.show_description,
        },
        sc: "User",
        billing_info: {
          first_name: form.firstName,
          last_name: form.lastName,
          email: form.email,
          street_address: form.address,
          // phone: formData.phone,
          // dot: formData.dot,
        },
        tl_account_id: res.data.memberId,
      }).then((res) => {
        if (!res) return;
        this.setState({
          bussinessCode: res.data.business_code,
          orderId: res.data.order_id,
          paymentCodes: true,
        });
        // To get order info
        getPaymentInfo({
          id: user.id,
          bussinessCode: res.data.business_code,
          orderId: res.data.order_id,
          verifykey: res.data.verify_key,
        }).then((res) => {
          if (!res) return;
          // Finally ~~ Go to pay what a clever mind
          this.setState({
            submitLoading: false,
            totalAmount: res.data[0].total_amount,
            loading:true // order loading
          });
          document
            .querySelector(
              ".common-Button-button.pages-Stripe-wide.common-Button-action.common-Button-large"
            )
            .click();
        });
      });
    });
  };
  setFormValue = (key, value) => {
    const form = {
      ...this.state.form,
      [key]: value,
    };
    this.setState({
      form,
    });
  };
  handleChange= (key, value) => {
    this.setFormValue(key, value);
  };
  handleBlur = (key, value) => {
    this.checkSingleField(key);
  };
  handleClosePop = () => {
    this.props.closePop()
    const query = getUrlQeury();
    if (!isEmpty(query) && query.from) {
      track("purchase_cancel", { source: query.from });
    }
  };
  getHigherMemberLevel = () => {
    const { accountLevel } = this.props.account;
  
    const result = []
    Object.keys(membershipLevel).forEach((key) => {
      if(membershipLevel[key] > accountLevel){
        result.push( {
          key:membershipLevel[key]
        })
      }
    })
    return result
  };
  componentDidMount(){
    const {payment,context} = this.props
    const { selectedBill } = payment
    const { paymentType, accountBillingCycle, originBillings, nowMembershipPlan } = context
    let nowMembeAnnuallyPlan = ''
    if(paymentType == 'Annually'){
      originBillings.forEach((bill) => {
        if(bill.grade_name == nowMembershipPlan && bill.bill_cycle == 'Annually'){
          nowMembeAnnuallyPlan = bill
        }
      })
    }
    
    const newMembershipInfo = accountBillingCycle.toLowerCase() == 'monthly' && nowMembeAnnuallyPlan ? nowMembeAnnuallyPlan : selectedBill
    this.setState({
      selectedBill:newMembershipInfo
    })
  }
  
  render() {
    
    const {
      stage,
      loading,
      form,
      error,
      orderStatus,
      payedInfo,
      paymentCodes,
      totalAmount,
      bussinessCode,
      orderId,
      submitLoading,
      selectedBill
    } = this.state;
    const { user, account, payment, context,saveOrderInfo,savePayInfo,saveOrderStatus,setOrderLoadingStatus } = this.props;
    const { id } = user;
    const { billCycle, nextBillDate, currentCost } = user.premiumInfo
    const { paymentType, accountBillingCycle, originBillings, billings, nowMembershipPlan } = context

    const { orderLoading } = payment
    const query = getUrlQeury();

    return <section className={`${css.membershipPlansModal } ${(orderStatus !== "successful" && orderLoading ? css.modalHide : '')}`}>
      {(orderStatus !== "successful" && !orderLoading) &&  <div>
        <div className={css.paymentDialogTitle}>Confirm your Membership Plan</div>
        <div className={css.paymentDiaSubtitle}>
          <span className={css.currentMemberShip}>Current Membership: {_.upperFirst(nowMembershipPlan)} {(currentCost && accountBillingCycle) ? `($${currentCost / 100} ${_.upperFirst(accountBillingCycle)})` : '' }</span>
          <span className={css.avaibleUngradedMemberShip}>New Membership: {_.upperFirst(selectedBill.grade_name)}  (${selectedBill.discount_price / 100} {_.upperFirst(selectedBill.bill_cycle)})</span>
          {nextBillDate &&<span className={css.billingDate}>Next billing date: {format(nextBillDate, 'MMM DD YYYY')}</span>}
        </div>
        
        {/* <div className={css.billInfoTitle}>
          <span className={css.splitLine}></span>
          <span className={css.billInfoTitleText}>
            Your bill contact information
          </span>
          <span className={css.splitLine}></span>
        </div> */}

        <div className={css.formWarp}>
          {/* <OrderForm
            form={form}
            error={error}
            handleBlur={this.handleBlur}
            handleChange={this.handleChange}
          ></OrderForm> */}
          <div className={css.btnWrap}>
            <Button
              className={css.wid}
              mods={['large']}
              onClick={() => {
                this.handleClosePop()
              }}
            >Cancel</Button>
            <Button
              className={css.wid}
              mods={['large', 'action']}
              onClick={() => {
                this.handleSubmit()
              }}
            >{this.state.submitLoading ? <LoadingSpiner /> : 'Confirm'}</Button>
          </div>
         
        </div>
      </div>}
      <div style={{ display: "none" }}>
        {paymentCodes && totalAmount && (
          <Stripe
            from="a"
            amount={Number(totalAmount || selectedBill.dicountPrice)}
            email={form.email}
            query={{ bussinessCode, orderId }}
            actionFn={(dispatch, getState, val) => {
              setOrderLoadingStatus(true)
              payOrderAction(dispatch, getState, {
                id,
                bussinessCode,
                orderId,
                token: val.token,
              }).then((res) => {
                const {code,data} = res;
                
                if(code == 100){
                  const payInfo = {
                    error:res.message
                  }
                  savePayInfo(payInfo)
                  saveOrderStatus('failure')
                  this.setState({
                    orderStatus: "failure",
                    payInfo,
                    loading: false
                  });
                }else{
                  const payedInfo = data || {};
                if (payedInfo.billing_info) {
                  const newBillInfo = {
                    ...payedInfo.billing_info,
                    // city: "",
                    // country: "",
                    // state: "",
                    // zip: "",
                  };
                  payedInfo.billing_info = newBillInfo;
                }
                saveOrderInfo(payedInfo)
                saveOrderStatus('successful')
                
                this.setState({
                  orderStatus: "successful",
                  payedInfo,
                  loading: false
                });
                }
                this.props.closePop()
                setOrderLoadingStatus(false)
                
                

                
                // if (!isEmpty(query)) {
                //   const level = selectedBill.key.split('_')[1];
                //   track('payment', {
                //     'pay successful': 1,
                //     source: query.from || 'Normal',
                //     membership: level,
                //     biilling_cycle: selectedBill.billCycle,
                //   });
                // } 

              

              });
            }}
          />
        )}
      </div>
    </section>;
  }
}

export default connect(
  ({ user, account,payment }) => ({ user, account,payment }),
  mapDispatch({
    closePop: () => modalClose(modes.MEMBERSHIP_PLANS),
    getPaymentInfos: (_, options) => getPaymentInfosAction(options),
    saveAccount: (_, params) => saveAccountAction(params),
    billInfo: (_, params) => billInfoAction(params),
    getPaymentInfo: (_, params) => getPaymentInfoAction(params),
    saveOrderInfo:(_, params) => saveOrderInfoAction(params),
    savePayInfo:(_, params) => savePayInfoAction(params),
    saveOrderStatus:(_,params) => saveOrderStatusAction(params),
    setOrderLoadingStatus:(_,params) => setOrderLoadingStatusAction(params)
  })
)(MembershipPlansModal);


// WEBPACK FOOTER //
// ./src/pages/MembershipPlans/components/PaymentModal/index.js